import type { IColumnInfo, IColumnRawInfo } from '@dbl/core/dataSource';
type TFieldIdentitySource = Pick<
IColumnRawInfo,
'table_id' | 'table_code' | 'column_name'
>;

/**
 * 【字段键匹配 — 开发重点关注】
 * - 匹配目标：操作区 existingColumns 与 dragOnMove 去重口径
 * - 本地键规则：`${table_id}_${table_code || 't0'}_${column_name}`
 * - table_code：自定义字段常为空，必须兜底 't0'
 */
export const getFieldDragIdentity = (field: TFieldIdentitySource): string => {
  const tableCode = field?.table_code || 't0';
  return `${field?.table_id}_${tableCode}_${field?.column_name}`;
};

export const columnInfoToFieldKey = (column: IColumnInfo): string =>
  getFieldDragIdentity(column);

/** 比较两个 key 集合是否完全一致；用于 applyBatchFields 判断勾选是否有实质变更 */
export const keysEqual = (a: Set<string>, b: Set<string>): boolean => {
  if (a.size !== b.size) {
    return false;
  }
  for (const key of a) {
    if (!b.has(key)) {
      return false;
    }
  }
  return true;
};
